module.exports = __webpack_public_path__ + "static/media/primary3.ebf4f7d6.png";